import * as React from "react";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InstrumentSelections } from "../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelections";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { NewTpsInvestmentsMessage } from "../../../NewBusinessWizard/Resource/Contents";
import { processTypeEnum } from "../../Resource/Contents";

interface INewTpsWarningProps extends IProcessComponentProps {
    data: ApplyModel;
    processType: processTypeEnum;
}

interface INewTpsWarningState {}

export class NewTpsWarning extends ProcessComponent<INewTpsWarningProps, INewTpsWarningState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }
    private hasNewTps(): boolean {
        const { data, processType } = this.props;

        if (processType == processTypeEnum.NewBusiness) {
            if (this.containNewTpsInstruments(data.GiaModel?.InstrumentSelections)) {
                return true;
            }
            if (this.containNewTpsInstruments(data.IsaModel?.InstrumentSelections)) {
                return true;
            }
            if (this.containNewTpsInstruments(data.PensionApply?.PostRetirementInstrumentSelections)) {
                return true;
            }
            if (this.containNewTpsInstruments(data.PensionApply?.PreRetirementInstrumentSelections)) {
                return true;
            }
            return false;
        }
        return false;
    }

    private containNewTpsInstruments(instrumentSelections: InstrumentSelections) {
        if (instrumentSelections != null) {
            const tpsInvestments = instrumentSelections.Instruments.filter(
                (instrument) => instrument.Instrument.Type == ProductType.TailoredModelPortfolio
            );
            return tpsInvestments.length > 0;
        }
        return false;
    }

    render() {
        return (
            <>
                {this.hasNewTps() && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            <>
                                {NewTpsInvestmentsMessage.messagePart1}
                                {NewTpsInvestmentsMessage.link}
                                {NewTpsInvestmentsMessage.messagePart2}
                            </>
                        }
                    />
                )}
            </>
        );
    }
}
